export enum AppointmentTypeDurationSuggestionStatus {
  Created = 1,
  Denied = 2,
  Modified = 3,
}
